import FeaturesItemImage from '@klv/molecules/features-item-image';
import { getColorVariantFromBackground } from '@klv/shared/utils/functions';
import Grid from '@klv/utils/grid';
import * as s from './styles';
import type { IFeaturesItemProps } from './types';

const FeaturesItem = ({
  variant, type, feature,
}: IFeaturesItemProps) => {
  const contentColorVariant = variant === 'dark' ? 'light' : 'dark';

  return (
    <Grid as="article">
      <s.StyledBorder $variant={variant} />
      {type === 'text'
      && <s.StyledHeaderLeftContent variant="contentHeaderListView1" forwardedAs="div" colorVariant={getColorVariantFromBackground(variant)}>{feature.leftColumnText}</s.StyledHeaderLeftContent>}
      {feature?.leftColumnImage && type === 'image'
      && <FeaturesItemImage variant={variant} image={feature.leftColumnImage} link={feature.link} />}
      <s.Feature $type={type}>
        <s.StyledHeaderContent variant="contentHeaderListView2" forwardedAs="h3" colorVariant={getColorVariantFromBackground(variant)}>{feature.heading}</s.StyledHeaderContent>
        {feature?.body && <s.StyledBodyContent colorVariant={contentColorVariant} variant="paragraph2" dangerouslySetInnerHTML={{ __html: feature.body }}/>}
        {feature?.buttons?.length && <s.StyledButtons buttons={feature.buttons} variants={['tertiary']} buttonColor={contentColorVariant} />}
      </s.Feature>
    </Grid>
  );
};

export default FeaturesItem;
